.wrapper {
  position: relative;
  margin-right: 1.2rem;
}

.host {
  width: 3.2rem;
  height: 3.2rem;
  overflow: hidden;
  border-radius: 0.8rem;
  box-shadow: 0 0 0 0.1rem var(--color-solitude-white);
  cursor: pointer;
}

.selected {
  box-shadow: 0 0 0 0.1rem var(--color-ziggurat);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 0.8rem;
  background: rgba(var(--color-mabel-rgb), 0.2);
}

.removeBtn {
  position: absolute;
  top: -0.6rem;
  right: -0.6rem;
  cursor: pointer;
}

.removeBtn svg {
  color: var(--color-semantic-text-neutral30);
}
